import { Component, OnInit } from '@angular/core';
import { MetaService } from '@ngx-meta/core';
import { traceButton2 } from '../../../../common/services/button-trace';
import { URL } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error-link-expired',
    templateUrl: './error-link-expired.component.html',
    styleUrls: ['./error-link-expired.component.scss']
})
export class ErrorLinkExpiredComponent implements OnInit {

    public URL = URL;

    constructor(
        private readonly _meta: MetaService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this._setMeta();
    }

    private _setMeta() {
        this._meta.setTag('author', 'CHILEFIRMAS');
        this._meta.setTag('og:type', 'website');
        this._meta.setTag('og:image:type', 'image/png');
        this._meta.setTag('og:image', this.URL.CHILEFIRMAS_WEBSITE + 'assets/images/og/og-error.png');
        this._meta.setTag('og:image:width', '644');
        this._meta.setTag('og:image:height', '373');
        this._meta.setTag('og:image:alt', 'El link al que estás ingresando ya caducó.');
        this._meta.setTag('twitter:card', 'summary_large_image');
        this._meta.setTag('twitter:site', '@Haulmerlat');
        this._meta.setTag('twitter:title', 'Enlace caducado - Chilefirmas');
        this._meta.setTag('twitter:description', 'El link al que estás ingresando ya caducó o no existe.');
        this._meta.setTag('twitter:image', this.URL.CHILEFIRMAS_WEBSITE + 'assets/images/og/og-error.png');
        this._meta.setTag('twitter:image:alt', 'El link al que estás ingresando ya caducó.');
    }

    redireccionarAHome(event: Event) {
        event.preventDefault();
        traceButton2(event, "navigate");
        this.router.navigate(['/']);
    }
}
